import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DevModePanelComponent } from './dev-tool-panel/dev-tool-panel.component';
import { DevToolService } from './dev-tool.service';
import { ENV } from '@core/env.token';

@Component({
  selector: 'app-dev-mode',
  imports: [
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './dev-tool.component.html',
  styleUrl: './dev-tool.component.scss',
})
export class DevModeComponent {
  readonly bottomSheet = inject(MatBottomSheet);
  readonly environment = inject(ENV);
  readonly devMode = inject(DevToolService);

  showPanel() {
    this.bottomSheet.open(DevModePanelComponent);
  }
}
